import { useState, useRef, useEffect } from "react";
import CTA from "../CTA/CTA";
import s from "./Cards.module.scss";

const Cards = ({
    title,
    text,
    img, 
    href,
}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [height, setHeight] = useState(0);
    const contentRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [isOpen]);


    return (
        <div className={s.card}>
            <div className={s.cardTitle} onClick={() => setIsOpen(!isOpen)}>
                <h3>{title}</h3>
                <img src="/atelier-de-la-villette/assets/icon/arrow.png" alt="" className={isOpen ? s.arrowOpen :""} />
            </div>
            <div ref={contentRef} className={`${s.cardContent} ${isOpen ? s.open : ""}`} style={{ maxHeight: isOpen ? `${height}px` : 0 }}>
                <img className={s.cardImage} src={img} alt="" />
                <p>{text}</p>
                <CTA
                    variant="icon"
                    text="Je demande un devis"
                    href={href}
                    icon={<img src="/atelier-de-la-villette/assets/icon/devis.png" alt="" />}
                />

            </div>

        </div>
    )
}

export default Cards;